export default __webpack_public_path__ + "static/media/workspaceSpaceman.a34b1d89.png";